module.exports = __webpack_public_path__ + "img/53.80a6aec3.png";